// extracted by mini-css-extract-plugin
export default {"pageTitle":"c14d7664"};